import React, { useState } from "react";
import { Flag, ImageIcon, X } from "lucide-react";
import RoomCard from "./RoomCard";
import { createModerationReport } from "../../../api/profileService";

export default function RoomMainImage({
  imageUrl,
  submittedBy,
  sourceType,
  correctAnswer,
  phase,
  categoryName,
  roundIndex,
  totalRounds,
  className = "",
}) {
  const [reportOpen, setReportOpen] = useState(false);
  const [reportCategory, setReportCategory] = useState("qualite");
  const [reportFeedback, setReportFeedback] = useState("");
  const isBreak = phase === "break";

  const submitImageReport = (e) => {
    e.preventDefault();
    createModerationReport({
      context_type: "image",
      category: reportCategory,
      reason: reportCategory,
      description: `Round ${roundIndex} - Categorie ${categoryName || "inconnue"}`,
    })
      .then(() => { setReportFeedback("Signalement envoye. Merci !"); setReportOpen(false); })
      .catch(() => setReportFeedback("Erreur lors du signalement."));
  };

  return (
    <>
    <RoomCard
      title="Image a deviner"

      action={
        <div className="rounded-full bg-orange-50 px-2.5 py-1 text-[11px] font-semibold text-orange-600">
          {roundIndex}/{totalRounds}
        </div>
      }
      contentClassName="!px-2 !pt-2 !pb-0"
      className={className}
    >
      <div className="relative overflow-hidden rounded-[22px] border border-slate-200 bg-slate-100 shadow-inner">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(251,191,36,0.22),transparent_45%),linear-gradient(135deg,rgba(255,255,255,0.15),rgba(15,23,42,0.18))]" />

        <div className="relative aspect-[16/10] overflow-hidden md:aspect-video">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Question"
              className={`h-full w-full object-cover transition duration-300 ${
                isBreak ? "scale-105 blur-sm brightness-75" : ""
              }`}
              draggable={false}
              onContextMenu={(event) => event.preventDefault()}
            />
          ) : (
            <div className="flex h-full items-center justify-center bg-[linear-gradient(145deg,#e2e8f0,#f8fafc)]">
              <div className="text-center text-slate-500">
                <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-white shadow-md">
                  <ImageIcon className="h-9 w-9" />
                </div>
                <p className="mt-4 text-lg font-medium text-slate-700">
                  Image en attente
                </p>
                <p className="mt-2 text-sm text-slate-500">
                  La prochaine image arrive dans quelques instants.
                </p>
              </div>
            </div>
          )}

          {null}

          {imageUrl && !isBreak && (
            <button
              type="button"
              onClick={() => { setReportOpen(true); setReportFeedback(""); }}
              className="absolute right-2 top-2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-black/40 text-white/70 backdrop-blur-sm transition hover:bg-black/60 hover:text-white"
              title="Signaler cette image"
            >
              <Flag className="h-3.5 w-3.5" />
            </button>
          )}

          {isBreak && (
            <div className="absolute inset-0 flex items-center justify-center bg-slate-950/35 p-6">
              <div className="rounded-3xl bg-white/90 px-5 py-4 text-center shadow-xl backdrop-blur">
                {correctAnswer ? (
                  <>
                    <p className="mt-1 text-xs text-slate-500">La réponse était :</p>
                    <p className="mt-1 text-xl font-black text-pixy-ink">
                      {correctAnswer}
                    </p>
                  </>
                ) : (
                  <p className="mt-2 text-base font-semibold text-slate-900">
                    Respire un coup, la prochaine image arrive.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </RoomCard>

    {reportOpen && (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 p-4 backdrop-blur-sm"
        onClick={() => setReportOpen(false)}
      >
        <div
          className="relative w-full max-w-sm rounded-[28px] bg-white p-6 shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between gap-3">
            <h2 className="text-base font-bold text-slate-900">Signaler cette image</h2>
            <button
              type="button"
              onClick={() => setReportOpen(false)}
              className="rounded-full p-1.5 text-slate-500 transition hover:bg-slate-100"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {reportFeedback ? (
            <div className="mt-4 rounded-2xl bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-600">
              {reportFeedback}
            </div>
          ) : (
            <form onSubmit={submitImageReport} className="mt-4 space-y-3">
              <select
                value={reportCategory}
                onChange={(e) => setReportCategory(e.target.value)}
                className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700"
              >
                <option value="qualite">Image de mauvaise qualité</option>
                <option value="affichage">Ne s'affiche pas</option>
                <option value="doublon">Doublon</option>
                <option value="ortho">Faute d'orthographe</option>
                <option value="non_conforme">Non-conforme</option>
                <option value="autre">Autre</option>
              </select>
              <div className="flex gap-2">
                <button
                  type="submit"
                  className="flex-1 rounded-xl bg-rose-600 px-3 py-2 text-sm font-bold text-white"
                >
                  Envoyer
                </button>
                <button
                  type="button"
                  onClick={() => setReportOpen(false)}
                  className="rounded-xl border border-slate-200 px-3 py-2 text-sm text-slate-600"
                >
                  Annuler
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    )}

    </>
  );
}
